import { getToken } from '../firebase/utils';

// Define multiple API URLs for different environments
const API_URL = process.env.REACT_APP_FIREBASE_URL || 'http://localhost:5000/api';

/**
 * Función base para realizar llamadas a la API con token de autorización
 */
const apiCall = async (endpoint, method, data = null) => {
  try {
    // Obtener el token de autorización usando la función getToken
    const token = await getToken();

    const headers = {
      'Content-Type': 'application/json',
      'x-authorization-token': token || ''
    };

    const options = {
      method,
      headers,
      ...(method !== 'GET' && data ? { body: JSON.stringify(data) } : {})
    };

    const response = await fetch(`${API_URL}/${endpoint}`, options);

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Error en la solicitud');
    }

    return response.status === 204 ? null : await response.json();
  } catch (error) {
    console.error('API call error:', error);
    throw error;
  }
};

/**
 * Registrar un nuevo usuario
 */
export const registerUser = async (userData) => {
  return apiCall('user/register', 'POST', userData);
};

/**
 * Obtener todos los usuarios
 */
export const getUsers = async () => {
  return apiCall('users', 'GET');
};

/**
 * Obtener un usuario por ID
 */
export const getUserById = async (userId) => {
  return apiCall(`user/${userId}`, 'GET');
};

/**
 * Actualizar un usuario existente
 */
export const updateUser = async (userId, userData) => {
  return apiCall(`user/profile/${userId}/update`, 'PATCH', userData);
};

/**
 * Eliminar un usuario
 */
export const deleteUser = async (userId) => {
  return apiCall(`user/profile/${userId}/delete`, 'DELETE');
};

/**
 * Cambiar la contraseña de un usuario
 */
export const changePassword = async (userId, passwordData) => {
  return apiCall(`user/${userId}/password`, 'PUT', passwordData);
};

/**
 * Cambiar el estado de habilitación de un usuario
 */
export const toggleUserStatus = async (userId, disabled) => {
  // Use the AWS API for this specific endpoint
  return apiCall(`user/profile/${userId}/status`, 'PUT', { disabled }, true);
};
export const healthcheck = async () => {
  // Use the AWS API for this specific endpoint
  return apiCall(`healthcheck`, 'GET');
};